export const Envs = {
  FUNCTIONS_URL:
    process.env['NX_FUNCTIONS_URL'] ??
    process.env['REACT_APP_FUNCTIONS_URL'] ??
    process.env['NEXT_PUBLIC_FUNCTIONS_URL'],
}
